import {
  FaAddressBook,
  FaTachometerAlt,
  FaUsers,
  FaUserFriends,
  FaShoppingCart,
  FaUserAstronaut,
  FaHornbill,
  FaVimeoV,
  FaHeadphones,
  FaArrowCircleDown,
  FaWarehouse,
  FaMoneyBillWave,
  FaCalculator,
  FaFileAlt,
  FaWaveSquare,
  FaFileCode,
  FaFileContract,
  FaGift,
  FaHome,
  FaSearch,
  FaPlus,
  FaEdit,
  FaBox,
  FaBoxOpen,
  FaPhone,
  FaHistory,
  FaCog,
  FaFileSignature,
  FaFileInvoiceDollar,
  FaChartBar,
  FaShoppingBag,
  FaCreditCard,
  FaUserPlus,
  FaUserCheck,
  FaDownload,
  FaFileDownload,
  FaFileUpload,
  FaFileExport,
  FaFileImport,
  FaClipboardList,
  FaClipboardCheck,
  FaClipboard,
  FaUserCog,
  FaUserShield,
  FaUserLock,
  FaUserEdit,
  FaUserClock,
  FaUserAlt,
  FaUserCircle,
  FaUserGraduate,
  FaUserNinja,
  FaUserSecret,
  FaUserTag,
  FaUserTie,
  FaUserTimes,
  FaUserMinus,
  FaUserSlash,
  FaUserInjured,
  FaUserMd,
  FaUserNurse,
  FaUsersCog,
  FagUsersSlash,
  FaInfoCircle,
  FaHandshake,
  FaChartLine,
  FaSimCard,
  FaMousePointer,
  FaShare,
  FaTruck,
  FaFileInvoice,
  FaVnv,
  FaTruckMoving,
  FaWifi,
  FaXRay,
  FaHospitalUser,
  FaEnvelopeOpenText,
  FaHouseDamage,
  FaMoneyCheck,
  FaCodiepie,
  FaSatelliteDish,
  FaSplotch,
  FaDiscourse,
  FaPause,
  FaInfo,
  FaAffiliatetheme,
  FaTags,
  FaSignal,
  FaFeatherAlt,
  FaTable,
  FaTabletAlt,
  FaTablets,
  FaTools,
  FaDollarSign,
  FaGlobe,
  FaPercent,
  FaBalanceScale,
  FaHandHoldingUsd,
} from "react-icons/fa"
import {
  HomeOutlined,
  DashboardOutlined,
  UserOutlined,
  TeamOutlined,
  ShoppingCartOutlined,
  FileSearchOutlined,
  FileAddOutlined,
  FileTextOutlined,
  SettingOutlined,
  UserAddOutlined,
  LockOutlined,
  InboxOutlined,
  ExportOutlined,
  PhoneOutlined,
  HistoryOutlined,
  CustomerServiceOutlined,
  FileProtectOutlined,
  AccountBookOutlined,
  BarChartOutlined,
  ShoppingOutlined,
  CreditCardOutlined,
  FileDoneOutlined,
} from "@ant-design/icons"
import ROUTER from "src/router"
import styled from "styled-components"
import STORAGE, { getStorage } from "src/lib/storage"
import { useSelector, useDispatch } from "react-redux"
import { ROLE } from "src/constants/constants"
import { Children } from "react"

const StyledIcon = styled.div`
  font-size: ${props => props.size || "22px"} !important;
  color: ${props => props.color || "rgb(0, 145, 199)"} !important;

  .menu-antd-user .ant-menu-item-icon svg path {
    fill: rgb(105, 86, 229) !important;
  }
`

export const MenuItem = () => {
  return [
    {
      label: "Giới thiệu",
      key: ROUTER.HOME,
      publishRouter: true,
      TabID: [1],
    },
  ]
}

export const MenuItemAdmin = () => {
  const role = localStorage.getItem(STORAGE.ROLES)
  // const permissions = localStorage.getItem(STORAGE.PERMISSIONS)
  // Lấy và xử lý danh sách quyền từ localStorage
  const permissions = localStorage.getItem(STORAGE.PERMISSIONS) || ""
  const level = localStorage.getItem(STORAGE.LEVEL)

  // Kiểm tra quyền chính xác (full match)
  // Hàm kiểm tra quyền
  const hasPermission = permissionKey => {
    if (!permissionKey) return true

    // nếu là mảng → chỉ cần 1 quyền hợp lệ
    if (Array.isArray(permissionKey)) {
      return permissionKey.some(key => permissions.includes(key))
    }

    // nếu là string
    return permissions.includes(permissionKey)
  }
  const { currentType } = useSelector(state => state.menu)
  console.log("Current Menu Type:", currentType)
  const filterMenuByPermission = menu =>
    menu
      .map(item => {
        const children = item.children
          ? filterMenuByPermission(item.children)
          : []

        const allowed = hasPermission(item.permissionKey) || children.length > 0
        if (!allowed) return null

        return {
          ...item,
          ...(children.length ? { children } : {}),
        }
      })
      .filter(Boolean)

  const filterLeaderMenu = (menu, level) => {
    return menu
      .filter(item => {
        // Lọc ra menu "Báo cáo" ở cấp cao nhất nếu level là 3
        if (level === "3" && item.key === "report") {
          return false
        }
        return true
      })
      .map(item => {
        const newItem = { ...item }

        if (newItem.children) {
          newItem.children = newItem.children.filter(child => {
            // Ẩn "Tạo tài khoản" nếu level === "3"
            if (level === "3" && child.key === ROUTER.AGENT_ACCOUNT_CREATE) {
              return false
            }

            // Ẩn "Điều khoản chính sách" nếu level là 1, 2 hoặc 3
            if (
              ["1", "2", "3"].includes(level) &&
              child.key === ROUTER.ACCOUNT_TERMS
            ) {
              return false
            }
            return true
          })
        }
        return newItem
      })
      .filter(item => !item.children || item.children.length > 0)
  }

  // Cách dùng:

  // Admin Menu
  const adminMenu = [
    ...(permissions.includes("system.htc")
      ? [
        {
          label: "Dashboard",
          icon: (
            <StyledIcon>
              <FaTachometerAlt />
            </StyledIcon>
          ),
          key: ROUTER.DASHBOARD,
          permissionKey: "dashboard",
          publishRouter: true,
        },
        {
          label: "Người dùng",
          icon: (
            <StyledIcon>
              <FaUsers />
            </StyledIcon>
          ),
          key: "userManagement",
          permissionKey: "users",
          publishRouter: true,
          TabID: [3],
          children: [
            {
              label: "Quản lý Admin",
              icon: (
                <StyledIcon>
                  <FaUserCircle />
                </StyledIcon>
              ),
              key: ROUTER.USER_MANAGEMENT,
              permissionKey: "users",
            },
            {
              label: "Quản lý B2B",
              icon: (
                <StyledIcon>
                  <FaUserAstronaut />
                </StyledIcon>
              ),
              key: ROUTER.AgencyManager,
              permissionKey: "users",
            },
            {
              label: "Quản lý B2C",
              icon: (
                <StyledIcon>
                  <FaUserNinja />
                </StyledIcon>
              ),
              key: ROUTER.AgencyManagerB2C,
              permissionKey: "users",
            },
            {
              label: "Quản lý Pool Data",
              icon: (
                <StyledIcon>
                  <FaUserCircle />
                </StyledIcon>
              ),
              key: ROUTER.POOL_DATA_USER_MANAGEMENT,
              permissionKey: "users",
            },
            {
              label: "Phân quyền",
              icon: (
                <StyledIcon>
                  <FaUserEdit />
                </StyledIcon>
              ),
              key: ROUTER.SETTING_PERMISSIONS,
              permissionKey: "permission.list",
            },
          ],
        },

        {
          label: "Quản lý nạp/rút tiền",
          icon: (
            <StyledIcon>
              <FaMoneyCheck />
            </StyledIcon>
          ),
          key: ROUTER.ACCOUNT_DEPOSITE_WITHDRAWAL,
          publishRouter: true,
          permissionKey: "wallet",
        },
        {
          label: "Quản lý khách hàng",
          icon: (
            <StyledIcon>
              <FaUserFriends />
            </StyledIcon>
          ),
          key: "customerManager",
          publishRouter: true,
          permissionKey: "customer",
          TabID: [7],
          children: [
            {
              label: "Quản lý hợp đồng khách hàng",
              icon: (
                <StyledIcon>
                  <FaXRay />
                </StyledIcon>
              ),
              key: ROUTER.CONTRACT_MANAGERMENT_CUSTOMER,
              permissionKey: "customer.contract",
            },
            {
              label: "Quản lý khách hàng",
              icon: (
                <StyledIcon>
                  <FaHospitalUser />
                </StyledIcon>
              ),
              key: ROUTER.CUSTOMER_MANAGERMENT,
              permissionKey: "customer.customer_manager",
            },
          ],
        },
        {
          label: "Quản lý nhà cung cấp",
          icon: (
            <StyledIcon>
              <FaTruck />
            </StyledIcon>
          ),
          key: "supplierManager",
          permissionKey: "supplier",
          publishRouter: true,
          TabID: [7],
          children: [
            {
              label: "Quản lý hợp đồng nhà cung cấp",
              icon: (
                <StyledIcon>
                  <FaXRay />
                </StyledIcon>
              ),
              key: ROUTER.CONTRACT_MANAGERMENT_SUPPLIER,
              permissionKey: "contract.supplier",
            },
            {
              label: "Quản lý nhà cung cấp",
              icon: (
                <StyledIcon>
                  <FaHospitalUser />
                </StyledIcon>
              ),
              key: ROUTER.SUPPLIER_MANAGERMENT,
              permissionKey: "supplier_manager.list",
            },
          ],
        },
        {
          label: "Quản lý nhà mạng",
          icon: (
            <StyledIcon>
              <FaSatelliteDish />
            </StyledIcon>
          ),
          key: ROUTER.NETWORK_MANAGER,
          publishRouter: true,
          permissionKey: "network",
        },
        {
          label: "Quản lý quốc gia",
          icon: (
            <StyledIcon>
              <FaGlobe />
            </StyledIcon>
          ),
          key: ROUTER.COUNTRY_MANAGER,
          // permissionKey: "dashboard",
          publishRouter: true,
        },
        // {
        //   label: "Quản lý affiliate",
        //   icon: (
        //     <StyledIcon>
        //       <FaAffiliatetheme />
        //     </StyledIcon>
        //   ),
        //   key: ROUTER.AFFILIATE_MANAGER,
        //   publishRouter: true,
        //   // permissionKey: "order",
        // },
        // {
        //   label: "Quản lý giá bán",
        //   icon: (
        //     <StyledIcon>
        //       <FaTags />
        //     </StyledIcon>
        //   ),
        //   key: ROUTER.SETTING_SIM_PRICE,
        //   permissionKey: "setting",
        //   publishRouter: true,
        //   // children: [
        //   //   {
        //   //     label: "Sim",
        //   //     icon: (
        //   //       <StyledIcon>
        //   //         <FaSimCard />
        //   //       </StyledIcon>
        //   //     ),
        //   //     key: ROUTER.SETTING_SIM_PRICE,
        //   //     // permissionKey: "order",
        //   //   },
        //   //   {
        //   //     label: "Gói cước",
        //   //     icon: (
        //   //       <StyledIcon>
        //   //         <FaSignal />
        //   //       </StyledIcon>
        //   //     ),
        //   //     key: ROUTER.SETTING_PACKAGE_PRICE,
        //   //     // permissionKey: "order",
        //   //   },
        //   // ],
        // },
        {
          label: "Đơn hàng",
          icon: (
            <StyledIcon>
              <FaShoppingCart />
            </StyledIcon>
          ),
          key: ROUTER.ACCOUNT_ORDER,
          publishRouter: true,
          permissionKey: "order",
          //   children: [
          //     {
          //       label: "Đơn hàng đại lý",
          //       icon: (
          //         <StyledIcon>
          //           <FaShoppingCart />
          //         </StyledIcon>
          //       ),
          //       key: ROUTER.ACCOUNT_ORDER,
          //       // permissionKey: "order",
          //     },
          //     // {
          //     //   label: "Đơn hàng affiliate",
          //     //   icon: (
          //     //     <StyledIcon>
          //     //      <FaAffiliatetheme />
          //     //     </StyledIcon>
          //     //   ),
          //     //   key: ROUTER.AFFILIATE_ORDER,
          //     //   // permissionKey: "order",
          //     // },
          //   ],
        },
        {
          label: "Quản lý kho",
          icon: (
            <StyledIcon>
              <FaBox />
            </StyledIcon>
          ),
          key: "warehouse_manager",
          permissionKey: "warehouse",
          publishRouter: true,
          TabID: [4],
          children: [
            // {
            //   label: "Phiếu đề xuất",
            //   icon: (
            //     <StyledIcon>
            //       <FaEnvelopeOpenText />
            //     </StyledIcon>
            //   ),
            //   key: ROUTER.ACCOUNT_LIST_REQUEST,},{
            //   label: "Kho đề xuất",
            //   icon: (
            //     <StyledIcon>
            //       <FaHouseDamage />
            //     </StyledIcon>
            //   ),
            //   key: ROUTER.SUGGESTED_WAREHOUSE,
            // },
            {
              label: "SIM",
              icon: (
                <StyledIcon>
                  <FaArrowCircleDown />
                </StyledIcon>
              ),
              key: ROUTER.SUGGESTED_WAREHOUSE,
              permissionKey: "warehouse",
              children: [
                // {
                //   label: "Kho đề xuất",
                //   icon: (
                //     <StyledIcon>
                //       <FaHouseDamage />
                //     </StyledIcon>
                //   ),
                //   key: ROUTER.SUGGESTED_WAREHOUSE,
                //   permissionKey: "warehouse.group_sim",
                // },
                {
                  label: "Phiếu nhập kho",
                  icon: (
                    <StyledIcon>
                      <FaEnvelopeOpenText />
                    </StyledIcon>
                  ),
                  key: ROUTER.ACCOUNT_LIST_REQUEST,
                  permissionKey: "warehouse.propose",
                },
                {
                  label: "Kho SIM",
                  icon: (
                    <StyledIcon>
                      <FaSimCard />
                    </StyledIcon>
                  ),
                  key: ROUTER.ACCOUNT_WAREHOUSE_IN,
                  permissionKey: "warehouse.sim",
                },
              ],
            },
            {
              label: "Data",
              icon: (
                <StyledIcon>
                  <FaWifi />
                </StyledIcon>
              ),
              key: "dataManagerment",
              permissionKey: "warehouse.data",
              children: [
                {
                  label: "Phiếu nhập kho",
                  icon: (
                    <StyledIcon>
                      <FaEnvelopeOpenText />
                    </StyledIcon>
                  ),
                  key: ROUTER.ACCOUNT_DATA_REQUEST,
                  permissionKey: "warehouse.data",
                },
                {
                  label: "Kho data",
                  icon: (
                    <StyledIcon>
                      <FaCodiepie />
                    </StyledIcon>
                  ),
                  key: ROUTER.ACCOUNT_WAREHOUSE_IN_DATA,
                  permissionKey: "warehouse.data",
                },
              ],
            },
            {
              label: "Xuất kho",
              icon: (
                <StyledIcon>
                  <FaTruckMoving />
                </StyledIcon>
              ),
              key: ROUTER.ACCOUNT_WAREHOUSE_OUT,
              permissionKey: "warehouse.export",
            },
          ],
        },
        {
          label: "Quản lý thuê bao",
          icon: (
            <StyledIcon>
              <FaPhone />
            </StyledIcon>
          ),
          key: ROUTER.SIM_MANAGER,
          publishRouter: true,
          TabID: [5],
          permissionKey: "management_sim",
          // children: [
          //   {
          //     label: "Quản lý Sim",
          //     icon: (
          //       <StyledIcon>
          //         <FaSimCard />
          //       </StyledIcon>
          //     ),
          //     key: ROUTER.SIM_MANAGER,
          //     permissionKey: "management_sim",
          //   },
          //   // {
          //   //   label: "QL gói cước",
          //   //   icon: (
          //   //     <StyledIcon>
          //   //       <FaInfoCircle />
          //   //     </StyledIcon>
          //   //   ),
          //   //   key: ROUTER.PACKAGE_MANAGER,
          //   // },
          // ],
        },
        {
          label: "Quản lý giá",
          icon: (
            <StyledIcon>
              <FaCog />
            </StyledIcon>
          ),
          key: "feeSettings",
          permissionKey: "package",
          publishRouter: true,
          TabID: [6],
          children: [
            {
              label: "Gói cước tự tạo ",
              icon: (
                <StyledIcon>
                  <FaVimeoV />
                </StyledIcon>
              ),
              key: ROUTER.PHONE_PACKAGE,
              permissionKey: "package.generate",
            },
            {
              label: "Gói cước nhà mạng",
              icon: (
                <StyledIcon>
                  <FaVnv />
                </StyledIcon>
              ),
              key: ROUTER.NetworkPackage,
              permissionKey: "package.net",
            },
            {
              label: "Yêu cầu chỉnh sửa gói cước",
              icon: (
                <StyledIcon>
                  <FaFeatherAlt />
                </StyledIcon>
              ),
              key: ROUTER.LIST_PACKAGE_REQUEST,
              permissionKey: "package.new",
            },
          ],
        },
        // {
        //   label: "Billing - tính cước",
        //   icon: (
        //     <StyledIcon>
        //       <FaFileInvoiceDollar />
        //     </StyledIcon>
        //   ),
        //   key: ROUTER.BILLING,
        //   permissionKey: "billing",
        //   publishRouter: true,
        //   TabID: [8],
        //   // children: [
        //   //   {
        //   //     label: "Billing - tính cước",
        //   //     icon: (
        //   //       <StyledIcon>
        //   //         <FaCalculator />
        //   //       </StyledIcon>
        //   //     ),
        //   //     key: ROUTER.BILLING,
        //   //     permissionKey: "billing",
        //   //   },
        //   //   // {
        //   //   //   label: "Hóa đơn",
        //   //   //   icon: (
        //   //   //     <StyledIcon>
        //   //   //       <FaFileInvoice />
        //   //   //     </StyledIcon>
        //   //   //   ),
        //   //   //   key: ROUTER.BILLING_INVOICE,
        //   //   // },
        //   // ],
        // },

        {
          label: "Báo cáo",
          icon: (
            <StyledIcon>
              <FaClipboardCheck />
            </StyledIcon>
          ),
          key: "report",
          permissionKey: "report",
          publishRouter: true,
          TabID: [3],
          children: [
            {
              label: "Báo cáo tổng quát",
              icon: (
                <StyledIcon>
                  <FaClipboardCheck />
                </StyledIcon>
              ),
              key: ROUTER.GENERAL_REPORT_ADMIN,
            },
            {
              label: "Báo cáo phần mua",
              icon: (
                <StyledIcon>
                  <FaTable />
                </StyledIcon>
              ),
              key: ROUTER.PURCHASE_REPORT,
              permissionKey: "report.approval.list",
            },
            {
              label: "Báo cáo phần bán",
              icon: (
                <StyledIcon>
                  <FaTabletAlt />
                </StyledIcon>
              ),
              key: ROUTER.SALES_REPORT,
              permissionKey: "report.sale.list",
            },
            {
              label: "Báo cáo tồn kho",
              icon: (
                <StyledIcon>
                  <FaTablets />
                </StyledIcon>
              ),
              key: ROUTER.INVENTORY_REPORT,
              permissionKey: "report.exists.list",
            },
          ],
        },
        ...(permissions.includes("question.list")
          ? [
            {
              label: "Q&A",
              icon: (
                <StyledIcon>
                  <FaSplotch />
                </StyledIcon>
              ),
              key: ROUTER.QUESTIONS_AND_ANSWERS,
              publishRouter: true,
              permissionKey: "question",
            },
          ]
          : []),
      ]
      : []),
  ]

  const hasSomePermission = (keys = []) =>
    keys.some(key => permissions.includes(key));
  // menu pool data
  const poolDataMenu = [
    ...(hasPermission("system.poolData")
      ? [
        ...(hasPermission("poolData.reportOverview.list")
          ? [
            {
              label: "Báo cáo tổng quát",
              icon: (
                <StyledIcon>
                  <FaClipboardCheck />
                </StyledIcon>
              ),
              key: ROUTER.GENERAL_REPORT_POOL_DATA,
              publishRouter: true,
            },
          ]
          : []),

        ...(hasPermission("poolData.sim")
          ? [
            {
              label: "Quản lý SIM",
              icon: (
                <StyledIcon>
                  <FaSimCard />
                </StyledIcon>
              ),
              key: ROUTER.SOLD_SIM_CARDS,
              publishRouter: true,
            },
          ]
          : []),

        ...(hasPermission("users")
          ? [
            {
              label: "Danh sách khách hàng",
              icon: (
                <StyledIcon>
                  <FaUserFriends />
                </StyledIcon>
              ),
              key: ROUTER.CUSTOMER_POOL_DATA,
              publishRouter: true,
            },
          ]
          : []),

        ...(hasSomePermission([
          "poolData.packageReceipt",
          "poolData.receipt",
          "walletData",
        ])
          ? [
            {
              label: "Phiếu nhập kho",
              icon: (
                <StyledIcon>
                  <FaEnvelopeOpenText />
                </StyledIcon>
              ),
              key: ROUTER.RECEIPT_POOL_DATA,
              publishRouter: true,
              children: [
                ...(hasPermission("poolData.receipt")
                  ? [
                    {
                      label: "SIM",
                      key: ROUTER.RECEIPT_POOL_DATA,
                    },
                  ]
                  : []),
                ...(hasPermission("poolData.packageReceipt")
                  ? [
                    {
                      label: "DATA",
                      key: ROUTER.DATA_RECEIPT_POOL_DATA,
                    },
                  ]
                  : []),
                ...(hasPermission("walletData")
                  ? [
                    {
                      label: "Ví data",
                      key: ROUTER.REPORT_POOL_WALLET,
                    },
                  ]
                  : []),
              ],
            },
          ]
          : []),

        ...(hasSomePermission([
          "poolData.order",
          "poolData.packageOrder",
        ])
          ? [
            {
              label: "Danh sách đơn hàng",
              icon: (
                <StyledIcon>
                  <FaShoppingCart />
                </StyledIcon>
              ),
              key: ROUTER.ORDER_POOL_DATA,
              publishRouter: true,
              children: [
                ...(hasPermission("poolData.order")
                  ? [
                    {
                      label: "SIM",
                      key: ROUTER.ORDER_POOL_DATA,
                    },
                  ]
                  : []),
                ...(hasPermission("poolData.packageOrder")
                  ? [
                    {
                      label: "DATA",
                      key: ROUTER.ORDER_DATA_M2M,
                    },
                  ]
                  : []),
              ],
            },
          ]
          : []),

        ...(hasPermission("poolData.priceSetting.list")
          ? [
            {
              label: "Cài đặt giá bán Data",
              icon: (
                <StyledIcon>
                  <FaCog />
                </StyledIcon>
              ),
              key: ROUTER.SETTING_PRICE_POOL_DATA,
              publishRouter: true,
            },
          ]
          : []),

        ...(hasSomePermission([
          "poolData.reportWallet",
        ])
          ? [
            {
              label: "Báo cáo ví",
              icon: (
                <StyledIcon>
                  <FaMoneyBillWave />
                </StyledIcon>
              ),
              key: ROUTER.REPORT_POOL_DATA_WALLET_BUY,
              publishRouter: true,
              // children: [
              //   ...(hasPermission("poolData.reportWallet.buy")
              //     ? [
              //       {
              //         label: "Báo cáo ví mua vào",
              //         key: ROUTER.REPORT_POOL_DATA_WALLET_BUY,
              //       },
              //     ]
              //     : []),
              //   ...(hasPermission("poolData.reportWallet.sell")
              //     ? [
              //       {
              //         label: "Báo cáo ví bán ra",
              //         key: ROUTER.REPORT_POOL_DATA_WALLET_SELL,
              //       },
              //     ]
              //     : []),
              //   ...(hasPermission("poolData.reportWallet.inventory")
              //     ? [
              //       {
              //         label: "Báo cáo ví tồn kho",
              //         key: ROUTER.REPORT_POOL_DATA_WALLET_INVENTORY,
              //       },
              //     ]
              //     : []),
              // ],
            },
          ]
          : []),

        ...(hasSomePermission([
          "poolData.reportData.list",
          "poolData.reportDataCustomer.list",
        ])
          ? [
            {
              label: "Báo cáo đối soát",
              icon: (
                <StyledIcon>
                  <FaBalanceScale />
                </StyledIcon>
              ),
              key: "report-pool-reconciliation",
              publishRouter: true,
              children: [
                ...(hasPermission("poolData.reportData.list")
                  ? [
                    {
                      label: "Báo cáo Data",
                      key: ROUTER.REPORT_POOL_DATA,
                    },
                  ]
                  : []),
                ...(hasPermission(
                  "poolData.reportDataCustomer.list"
                ) && role !== "ADMIN"
                  ? [
                    {
                      label: "Báo cáo đối soát",
                      key: ROUTER.REPORT_RECONCILIATION_POOL_DATA,
                    },
                  ]
                  : []),
              ],
            },
          ]
          : []),

        ...(hasSomePermission([
          "poolData.reportSim.listReceipt",
          "poolData.reportSim.listOrder",
          "poolData.reportStatusSim.list",
          "poolData.reportSim.listInventory",
        ])
          ? [
            {
              label: "Báo cáo SIM",
              icon: (
                <StyledIcon>
                  <FaSimCard />
                </StyledIcon>
              ),
              key: "report-pool-sim",
              publishRouter: true,
              children: [
                ...(hasPermission("poolData.reportSim.listReceipt")
                  ? [
                    {
                      label: "Báo cáo mua",    
                      key: ROUTER.REPORT_POOL_DATA_PURCHASE,
                    },
                  ]
                  : []),
                ...(hasPermission("poolData.reportSim.listOrder")
                  ? [
                    {
                      label: "Báo cáo bán",
                      key: ROUTER.REPORT_POOL_DATA_SALE,
                    },
                  ]
                  : []),
                ...(hasPermission("poolData.reportStatusSim.list")
                  ? [
                    {
                      label: "Báo cáo trạng thái SIM",
                      key: ROUTER.REPORT_POOL_SIM,
                    },
                  ]
                  : []),
                ...(hasPermission("poolData.reportSim.listInventory")
                  ? [
                    {
                      label: "Báo cáo tồn SIM",
                      key: ROUTER.REPORT_INVENTORY_POOL_DATA,
                    },
                  ]
                  : []),
              ],
            },
          ]
          : []),

        ...(hasPermission([
          "poolData.reportPackage.listReceipt",
          "poolData.reportPackage.listOrder",
          "poolData.reportPackage.listInventory",
        ])
          ? [
            {
              label: "Báo cáo data",
              icon: (
                <StyledIcon>
                  <FaBox />
                </StyledIcon>
              ),
              key: "report-pool-data",
              publishRouter: true,
              children: [
                ...(hasPermission("poolData.reportPackage.listReceipt")
                  ? [
                    {
                      label: "Báo cáo mua gói",
                      key: ROUTER.REPORT_RECEIPT_M2M,
                    },
                  ]
                  : []),
                ...(hasPermission("poolData.reportPackage.listOrder")
                  ? [
                    {
                      label: "Báo cáo gói đã sử dụng",
                      key: ROUTER.REPORT_ORDER_M2M,
                    },
                  ]
                  : []),
                ...(hasPermission("poolData.reportPackage.listInventory")
                  ? [
                    {
                      label: "Báo cáo tồn gói",
                      key: ROUTER.REPORT_PACKAGE_INVENTORY_M2M,
                    },
                  ]
                  : []),
              ],
            },
          ]
          : []),
           ...(hasPermission("poolData.packageConfig.list") ?[{
            label: "Cấu hình data",
            icon: (
              <StyledIcon>
                <FaCog />
              </StyledIcon>
            ),
            key: ROUTER.SUBSCRIPTION_PACKAGE_CONFIG,
            publishRouter: true,
          }] : [])
          
      ]
      : []),
  ];

  // Leader Menu
  const leaderMenu = [
    {
      label: "Quản lý tài khoản",
      icon: (
        <StyledIcon>
          <FaUserCircle />
        </StyledIcon>
      ),
      key: "accountManagerment",
      publishRouter: true,
      TabID: [1],
      children: [
        // {
        //   label: "Thông tin tài khoản",
        //   icon: (
        //     <StyledIcon>
        //       <FaInfoCircle />
        //     </StyledIcon>
        //   ),
        //   key: ROUTER.ACCOUNT,
        // },
        {
          label: "Hợp đồng khách hàng",
          icon: (
            <StyledIcon>
              <FaFileContract />
            </StyledIcon>
          ),
          key: ROUTER.ACCOUNT_TERMS,
        },
        {
          label: "Thanh toán",
          icon: (
            <StyledIcon>
              <FaCreditCard />
            </StyledIcon>
          ),
          key: ROUTER.ACCOUNT_PAYMENT,
        },
      ],
    },
    // {
    //   label: "Hỗ trợ đại lý",
    //   icon: (
    //     <StyledIcon>
    //       <FaHandshake />
    //     </StyledIcon>
    //   ),
    //   key: "agentSupport",
    //   publishRouter: true,
    //   TabID: [2],
    //   children: [

    //   ],
    // },
    {
      label: "Tạo tài khoản đại lý",
      icon: (
        <StyledIcon>
          <FaUserCircle />
        </StyledIcon>
      ),
      key: ROUTER.AGENT_ACCOUNT_CREATE,
      levelKey: level,
      publishRouter: level !== "3",
    },
    // {
    //   label: "Dịch vụ trả trước",
    //   icon: (
    //     <StyledIcon>
    //       <FaMoneyBillWave />
    //     </StyledIcon>
    //   ),
    //   key: ROUTER.AGENT_PREPAID_SERVICE,
    // },
    // {
    //   label: "Dịch vụ trả sau",
    //   icon: (
    //     <StyledIcon>
    //       <FaMoneyBillWave />
    //     </StyledIcon>
    //   ),
    //   key: ROUTER.AGENT_POSTPAID_SERVICE,
    // },
    {
      label: "Quản lý đơn hàng",
      icon: (
        <StyledIcon>
          <FaMoneyBillWave />
        </StyledIcon>
      ),
      key: ROUTER.AGENT_SIM_PACKAGE_SERVICE,
      publishRouter: true,
    },
    {
      label: "Đặt/Mua hàng",
      icon: (
        <StyledIcon>
          <FaShoppingCart />
        </StyledIcon>
      ),
      key: ROUTER.SALES_BUY_PACKAGE,
      publishRouter: true,
    },
    // {
    //   label: "Quản lý đơn hàng xuất kho",
    //   icon: (
    //     <StyledIcon>
    //       <FaTruckMoving />
    //     </StyledIcon>
    //   ),
    //   key: ROUTER.HISTORY_ORDER,
    //   publishRouter: true,
    // },
    {
      label: "Đơn hàng đại lý con",
      icon: (
        <StyledIcon>
          <FaHospitalUser />
        </StyledIcon>
      ),
      key: ROUTER.LIST_ORDER_AGENCY_CHILD,
      publishRouter: true,
    },
    // {
    //   label: "Mua gói cước",
    //   icon: (
    //     <StyledIcon>
    //       <FaShoppingCart />
    //     </StyledIcon>
    //   ),
    //   publishRouter: true,
    //   key: ROUTER.PACKAGE_PURCHASE,
    // },
    {
      label: "Cấu hình giá bán & hoa hồng",
      icon: (
        <StyledIcon>
          <FaCog />
        </StyledIcon>
      ),
      publishRouter: true,
      TabID: [3],
      children: [
        ...(level === "0"
          ? [
            {
              label: "Cấu hình giá bán & hoa hồng",
              icon: (
                <StyledIcon>
                  <FaCog />
                </StyledIcon>
              ),
              publishRouter: level === "0",
              key: ROUTER.PACKAGE_SALE_TYPE,
            },
          ]
          : []),
        {
          label: "Setting hoa hồng",
          icon: (
            <StyledIcon>
              <FaPercent />
            </StyledIcon>
          ),
          publishRouter: true,
          key: ROUTER.SETTING_DISCOUNT,
        },

        {
          label: "Cài đặt giá bán",
          icon: (
            <StyledIcon>
              <FaDollarSign />
            </StyledIcon>
          ),
          publishRouter: true,
          key: ROUTER.PACKAGE_PRICING,
        },
      ],
    },
    {
      label: "Quản lý thuê bao",
      icon: (
        <StyledIcon>
          <FaPhone />
        </StyledIcon>
      ),
      key: "subscriptionManagement",
      publishRouter: true,
      TabID: [3],
      children: [
        {
          label: "Quản lý Sim",
          icon: (
            <StyledIcon>
              <FaSimCard />
            </StyledIcon>
          ),
          key: ROUTER.SIM_MANAGER_SEARCH,
        },
        // {
        //   label: "Quản lý gói cước",
        //   icon: (
        //     <StyledIcon>
        //       <FaVimeoV />
        //     </StyledIcon>
        //   ),
        //   key: ROUTER.PACKAGE_MANAGEMENT_SEARCH,
        // },
        {
          label: "Quản lý Data",
          icon: (
            <StyledIcon>
              <FaWifi />
            </StyledIcon>
          ),
          key: ROUTER.DATA_MANAGER,
          // permissionKey: "warehouse.data",
        },
      ],
    },
    // {
    //   label: "Quản lý khách hàng",
    //   icon: (
    //     <StyledIcon>
    //       <FaUsers />
    //     </StyledIcon>
    //   ),
    //   key: "customerManagerment",
    //   publishRouter: true,
    //   TabID: [4],
    //   children: [
    //     {
    //       label: "Tra cứu danh sách khách hàng",
    //       icon: (
    //         <StyledIcon>
    //           <FaSearch />
    //         </StyledIcon>
    //       ),
    //       key: ROUTER.CUSTOMER_MANAGERMENT_SEARCH,
    //     },
    //     {
    //       label: "Tải danh sách khách hàng",
    //       icon: (
    //         <StyledIcon>
    //           <FaDownload />
    //         </StyledIcon>
    //       ),
    //       key: ROUTER.CUSTOMER_MANAGERMENT_DOWNLOAD,
    //     },
    //   ],
    // },
    // {
    //   label: "Doanh thu",
    //   icon: (
    //     <StyledIcon>
    //       <FaChartLine />
    //     </StyledIcon>
    //   ),
    //   key: "revenue",
    //   publishRouter: true,
    //   TabID: [5],
    //   children: [
    //     {
    //       label: "Lượng sim bán",
    //       icon: (
    //         <StyledIcon>
    //           <FaSimCard />
    //         </StyledIcon>
    //       ),
    //       key: ROUTER.REVENUE_SIM_QUANTITY_SOLD,
    //     },
    //     {
    //       label: "Gói cước bán",
    //       icon: (
    //         <StyledIcon>
    //           <FaBox />
    //         </StyledIcon>
    //       ),
    //       key: ROUTER.REVENUE_PACKAGE_SOLD,
    //     },
    //     {
    //       label: "Tăng trưởng",
    //       icon: (
    //         <StyledIcon>
    //           <FaChartLine />
    //         </StyledIcon>
    //       ),
    //       key: ROUTER.GROETH,
    //     },
    //     {
    //       label: "Tổng doanh thu",
    //       icon: (
    //         <StyledIcon>
    //           <FaCalculator />
    //         </StyledIcon>
    //       ),
    //       key: ROUTER.REVENUE_TOTAL,
    //     },
    //     {
    //       label: "Tổng khách hàng",
    //       icon: (
    //         <StyledIcon>
    //           <FaUsers />
    //         </StyledIcon>
    //       ),
    //       key: ROUTER.REVENUE_CUSTOMER_TOTAL,
    //     },
    //   ],
    // },
    {
      label: "Báo cáo",
      icon: (
        <StyledIcon>
          <FaClipboardCheck />
        </StyledIcon>
      ),
      // permissionKey: "report",
      publishRouter: true,
      TabID: [3],
      // levelKey: level,
      children: [
        {
          label: "Báo cáo tổng quát",
          icon: (
            <StyledIcon>
              <FaClipboardCheck />
            </StyledIcon>
          ),
          key: ROUTER.GENERAL_REPORT_B2B,
        },
        {
          label: "Báo cáo phần mua",
          icon: (
            <StyledIcon>
              <FaTable />
            </StyledIcon>
          ),
          key: ROUTER.PURCHASE_REPORT_B2B,
        },
        {
          label: "Báo cáo phần bán",
          icon: (
            <StyledIcon>
              <FaTabletAlt />
            </StyledIcon>
          ),
          key: ROUTER.SALES_REPORT_B2B,
        },
        {
          label: "Báo cáo bán lẻ",
          icon: (
            <StyledIcon>
              <FaTabletAlt />
            </StyledIcon>
          ),
          key: ROUTER.RETAIL_REPORT_B2B,
        },
        {
          label: "Báo cáo tồn kho",
          icon: (
            <StyledIcon>
              <FaTablets />
            </StyledIcon>
          ),
          key: ROUTER.INVENTORY_REPORT_B2B,
        },
        {
          label: "Báo cáo theo hình thức bán",
          icon: (
            <StyledIcon>
              <FaTablets />
            </StyledIcon>
          ),
          key: ROUTER.SALE_SETTING_REPORT,
        },
      ],
    },

    {
      label: "Tài liệu",
      icon: (
        <StyledIcon>
          <FaDiscourse />
        </StyledIcon>
      ),
      key: "document",
      publishRouter: true,
      TabID: [3],
      children: [
        {
          label: "Hướng dẫn sử dụng",
          icon: (
            <StyledIcon>
              <FaPause />
            </StyledIcon>
          ),
          key: ROUTER.USER_MANUAL,
        },
        {
          label: "Thông tin mới về SIM,DATA",
          icon: (
            <StyledIcon>
              <FaInfo />
            </StyledIcon>
          ),
          key: ROUTER.NEW_SIM_DATA_INFORMATION,
        },
      ],
    },
  ]

  // Staff Menu
  const staffMenu = [
    {
      label: "Dashboard",
      icon: (
        <StyledIcon>
          <FaTachometerAlt />
        </StyledIcon>
      ),
      key: ROUTER.DASHBOARDB2C,
      publishRouter: true,
      // TabID: [1],
      // children: [
      //   // {
      //   //   label: "Lượt mua",
      //   //   icon: (
      //   //     <StyledIcon>
      //   //       <FaShoppingCart />
      //   //     </StyledIcon>
      //   //   ),
      //   //   key: ROUTER.DASHBOARD_PURCHASE,
      //   // },
      //   // {
      //   //   label: "Lượt Click",
      //   //   icon: (
      //   //     <StyledIcon>
      //   //       <FaMousePointer />
      //   //     </StyledIcon>
      //   //   ),
      //   //   key: ROUTER.DASHBOARD_CLICK,
      //   // },
      //   // {
      //   //   label: "Doanh thu",
      //   //   icon: (
      //   //     <StyledIcon>
      //   //       <FaChartLine />
      //   //     </StyledIcon>
      //   //   ),
      //   //   key: ROUTER.DASHBOARD_REVENUE,
      //   // },
      //   // {
      //   //   label: "Mã giới thiệu",
      //   //   icon: (
      //   //     <StyledIcon>
      //   //       <FaShare />
      //   //     </StyledIcon>
      //   //   ),
      //   //   key: ROUTER.DASHBOARD_REFERRAL,
      //   // },
      // ],
    },
    //  {
    //   label: "Đơn hàng",
    //   icon: (
    //     <StyledIcon>
    //       <FaShoppingCart />
    //     </StyledIcon>
    //   ),
    //   key: ROUTER.ACCOUNT_ORDER,
    //   publishRouter: true,
    //   permissionKey: "order",
    // },

    {
      label: "Quản lý tài khoản",
      icon: (
        <StyledIcon>
          <FaUserCircle />
        </StyledIcon>
      ),
      key: "account",
      publishRouter: true,
      TabID: [2],
      children: [
        {
          label: "Điều khoản chính sách",
          icon: (
            <StyledIcon>
              <FaFileContract />
            </StyledIcon>
          ),
          key: ROUTER.USER_TERMS,
        },
        {
          label: "Ví cá nhân",
          icon: (
            <StyledIcon>
              <FaCreditCard />
            </StyledIcon>
          ),
          key: ROUTER.PAYMENT,
        },
      ],
    },
    {
      label: "Bán hàng",
      icon: (
        <StyledIcon>
          <FaShoppingBag />
        </StyledIcon>
      ),
      key: "sales",
      publishRouter: true,
      TabID: [3],
      children: [
        {
          label: "Mua SIM",
          icon: (
            <StyledIcon>
              <FaSimCard />
            </StyledIcon>
          ),
          key: ROUTER.SALES_BUY_SIM,
        },
        {
          label: "Đặt hàng",
          icon: (
            <StyledIcon>
              <FaBox />
            </StyledIcon>
          ),
          key: ROUTER.SALES_BUY_PACKAGE,
        },
      ],
    },
  ]

  console.log("role", role)
  const filteredMenu = filterMenuByPermission(
    currentType === "admin" ? adminMenu : poolDataMenu,
  )
  console.log(poolDataMenu, "poolDataMenu")
  const menuLeader = filterLeaderMenu(leaderMenu, level)
  switch (role) {
    case ROLE.ADMIN:
    case ROLE.CUSTOMER:
      return filteredMenu
    case ROLE.LEADER:
      return menuLeader
    case ROLE.STAFF:
      return staffMenu
    default:
      return []
  }
}
